import React from "react";

import { SkeletonRow, SkeletonRows } from "./styles";
import { SectionSkeletonRowsProps } from "./types";

export const SectionSkeletonRows: React.FC<SectionSkeletonRowsProps> = ({
  count,
  label,
}) => (
  <SkeletonRows role="status" aria-label={label}>
    {Array.from({ length: count }, (_, index) => (
      <SkeletonRow key={index} />
    ))}
  </SkeletonRows>
);
